import styles from './render-section.module.scss';

export function RenderSection({ header, headerId, children }) {
  return (
    <div className={styles.section}>
      {header && <h6 id={headerId}>{header}</h6>}
      {children}
    </div>
  );
}
